<template>
  <li class="tempus-cart nav-item dropdown float-left" style="width: 42px; height: 45px" v-if="cart && inToggle && ! ($mq == 'sm' || $mq == 'xs' || $mq == 'md') && location && cart.cart_items.length">
    <a
      class="nav-link webLink"
      href="#"
      style="height: 31px; display: inline-block;"
      role="button" data-toggle="dropdown">
      <span class="cart-empty" :class="$deploymentIn(['coalville', 'beyondbreakout', 'escapereading', 'prodigy', 'funkysnake']) ? 'cart-dark' : ''"></span>
      <span class="cart-qty cryptology-font-shadow" :class="$deploymentIn(['coalville', 'beyondbreakout', 'prodigy']) ? 'text-indigo' : 'text-tempus-red'">
        <template v-if="$deploymentIn(['beyondbreakout'])">
          <span class="font-weight-bold" style="font-size: 110%; position: relative; bottom: 17px">
            {{ cart.cart_items.length }}
          </span>
        </template>
        <template v-else>
          {{ cart.cart_items.length }}
        </template>
      </span>
    </a>

    <div class="dropdown-menu dropdown-menu-right" :class="$deploymentIn(['breakescape', 'taketheexit', 'makeyourescape', 'escapable', 'paralysis', 'escapegoat', 'rushden', 'missionclassified', 'panicroomharlow', 'escaporium', 'oo7escaperooms', 'lakesescapes']) ? 'text-white' : 'text-black'" style="width: 300px;">
      <div class="p-2">
        <p class="mb-0 heading">Your cart contains:</p>
        <div class="dropdown-divider"></div>
        <p class="mb-0" v-for="cartItem in cart.cart_items" :key="cartItem.id">
          <span class="material-icons" style="position: relative; top: 7px;">{{ cartItem.materialIcon }}</span>
          {{ cartItem.descriptionShort }}
          <span v-if="cartItem.cartable_type == 'App\\Models\\RoomSlot'">for {{ cartItem.quantity }}pax</span>
          <span v-else-if="cartItem.cartable_type == 'App\\Models\\Product'">&times; {{ cartItem.quantity }}</span>
          <span v-else-if="cartItem.cartable_type == 'App\\Models\\VirtualGame'">&times; {{ cartItem.quantity }}</span>
          <span v-else-if="cartItem.cartable_type == 'App\\Models\\VoucherProduct'">&times; {{ cartItem.quantity }}</span>
        </p>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item tempus-cart-empty-cart-button empty-cart" @click="emptyCartButton">Empty Cart</a>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item tempus-cart-checkout-button btn-block" :href="route('location.checkout', this.location)">Checkout</a>
      </div>
    </div>
  </li>
  <div v-else-if="cart && ! inToggle && ($mq == 'sm' || $mq == 'xs'|| $mq == 'md') && location && cart.cart_items.length" style="height: 45px;" class="tempus-cart">
    <a
      class="nav-link webLink"
      href="#"
      style="height: 31px; display: inline-block;"
      role="button" data-toggle="dropdown">
      <span class="cart-empty" :class="$deploymentIn(['coalville', 'beyondbreakout', 'escapereading', 'prodigy', 'funkysnake']) ? 'cart-dark' : ''"></span>
      <span class="cart-qty cryptology-font-shadow" :class="$deploymentIn(['coalville', 'beyondbreakout', 'escapereading', 'prodigy']) ? 'text-indigo' : 'text-tempus-red'">
        <template v-if="$deploymentIn(['beyondbreakout'])">
          <span class="font-weight-bold" style="font-size: 110%; position: relative; bottom: 17px">
            {{ cart.cart_items.length }}
          </span>
        </template>
        <template v-else>
          {{ cart.cart_items.length }}
        </template>
      </span>
    </a>

    <div class="dropdown-menu" :class="$deploymentIn(['breakescape', 'taketheexit', 'makeyourescape', 'escapable', 'paralysis', 'escapegoat', 'rushden', 'missionclassified', 'panicroomharlow', 'escaporium', 'oo7escaperooms', 'lakesescapes']) ? 'text-white' : 'text-black'" style="width: 300px;">
      <div class="p-2">
        <p class="mb-0 heading">Your cart contains:</p>
        <div class="dropdown-divider"></div>
        <p class="mb-0" v-for="cartItem in cart.cart_items" :key="cartItem.id">
          <span class="material-icons" style="position: relative; top: 7px;">{{ cartItem.materialIcon }}</span>
          {{ cartItem.descriptionShort }}
          <span v-if="cartItem.cartable_type == 'App\\Models\\RoomSlot'">for {{ cartItem.quantity }}pax</span>
          <span v-else-if="cartItem.cartable_type == 'App\\Models\\Product'">&times; {{ cartItem.quantity }}</span>
        </p>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item btn btn-dark-red btn-block empty-cart" @click="emptyCartButton">Empty Cart</a>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item btn btn-dark-green btn-block" :href="route('location.checkout', location)">Checkout</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    location: {
      type: Object,
    },
    initialCart: {
      type: Object,
    },
    inToggle: {
      type: Boolean
    }
  },

  data() {
    return {
      cart: Vue.util.extend({}, JSON.parse(JSON.stringify(this.initialCart))),
    };
  },

  methods: {
    emptyCartButton(event) {
      // console.log('removeCartItemButton', cartItem);

      const self = this;

      $('.empty-cart').confirmation('dispose');
      $('.empty-cart').removeClass('empty-cart');
      event.target.classList.add('empty-cart');

      // confirmation popover
      let options = {
        container: 'body',
        rootSelector: '.empty-cart',
        title: 'Empty your cart?',
        popout: true,
        singleton: true,
        btnOkClass: 'btn btn-sm btn-green',
        btnCancelClass: 'btn btn-sm btn-red',
        placement: 'right',
        trigger: 'manual',
        onConfirm(value) {
          event.target.classList.remove('empty-cart');

          self.$nextTick(function () {
            self.cartEmpty();
          });
        },
        onCancel(value) {
          event.target.classList.remove('empty-cart');
        },
      };

      $('.empty-cart').confirmation(options);
      $('.empty-cart').on('hidden.bs.confirmation', function (event) {
        event.target.classList.remove('empty-cart');
      });
      $('.empty-cart').confirmation('show');
    },

    cartEmpty() {
      // console.log('cartEmpty()');

      let request = {
        location: this.location.slug,
      }

      this.loading(true);
      axios.delete(this.route('api.cart-current.destroy'), {data: request})
        .then((response) => {
          if (response.status == 200) {
            this.cart = response.data;
          } else {
            flash('Error emptying Cart', 'danger');
            console.log('cartEmpty', response.data);
            console.log('cartEmpty', response.status);
            console.log('cartEmpty', response.statusText);
          }

          this.loading(false);
        })
        .catch((error) => {
          flash('Error emptying Cart', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('cartEmpty:422', error.response.data);
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('cartEmpty:409', error.response.data);
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('cartEmpty:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('cartEmpty:401', error.response.data);
              window.location.reload();
            } else {
              console.log('cartEmpty: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('cartEmpty: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('cartEmpty: Error', error.message);
          }
          this.loading(false);
        });
    },

    /* ===============
     * Echo methods
     */

    cartSavedEvent(event) {
      // console.log('cartSavedEvent(event)', event);
      if (! this.disableCartEchoUpdateFlag) {
        this.cart = event.cart;
      } else {
        this.temporaryCart = event.cart;
      }
    },

    enableCartEchoUpdate() {
      this.disableCartEchoUpdateFlag = false;

      if (this.temporaryCart) {
        this.cart = this.temporaryCart;
        this.temporaryCart = null;
      }
    },

    disableCartEchoUpdate() {
      this.disableCartEchoUpdateFlag = true;
      this.temporaryCart = null;
    },

    echoInitCart() {
      if (! process.env.MIX_PUSHER_APP_KEY) {
        return;
      }

      Echo.channel('cart.session.' + this.cart.session)
        .listen('Cart.CartSaved', this.cartSavedEvent);

      this.enableCartEchoUpdate();
    },

    echoDeInitCart() {
      if (! process.env.MIX_PUSHER_APP_KEY) {
        return;
      }

      Echo.leave('cart.session.' + this.cart.session);
      Echo.leave('booking-calendar.cart.session.' + this.cart.session)
    },

    /*
     * END Echo methods
     * =============== */
  },

  mounted() {
    this.echoInitCart();
    // $('.dropdown-toggle').removeAttr('data-toggle');
  },

  beforeDestroy() {
    this.echoDeInitCart();
  },
}
</script>
